import { VHeaders } from '@/models/pagedlistmodel';

export function getHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('epicorAttachments.epicorGrid.name') as string,
      align: 'left',
      value: 'attachmentName',
    },
    {
      text: vm.$parent.$t(
        'epicorAttachments.epicorGrid.lastModified'
      ) as string,
      align: 'left',
      value: 'lastModified',
      fieldType: 'date',
    },
    {
      text: vm.$parent.$t('epicorAttachments.epicorGrid.action') as string,
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];
}
